export default "__VITE_ASSET__B1F3psrB__"